import { excelExportHttpClient } from './excelExportHttpClient';

export interface ExportFilters {
    dateRange?: [Date | null, Date | null];
    status?: string[];
    sapOutcome?: string[];
    advertisingZone?: string[];
    procurementManagerIds?: string[];
    operationsAreaIds?: string[];
    divisionIds?: string[];
    standInDivisionIds?: string[];
    storeIds?: string[];
    globalFilter?: string;
    friendlyId?: string;
    productSku?: string;
    productCategory?: string[];
    createdAtStart?: Date;
    createdAtEnd?: Date;
    includeCostPricesAndMargins?: boolean;
    priceChangeScope?: string[];
    isFromPriceSurvey?: string[];
    isAutoDeclined?: boolean;
}

export interface ExportSurveyFilters {
    statuses?: string[];
    search?: string;
    advertisingZoneId?: string;
    advertisingZoneIds?: string[];
    storeId?: string;
    storeIds?: string[];
    surveyType?: string;
    surveyTypes?: string[];
    createdAtStart?: string;
    createdAtEnd?: string;
}

export function buildPriceChangeExportRequestBody(
    requestIds: string[] | null,
    filters?: ExportFilters,
): { requestIds: string[] | null; filters: unknown } {
    const processedFilters = filters
        ? {
              ...filters,
              ...(filters.dateRange
                  ? {
                        createdAtStart: filters.dateRange[0]?.toISOString(),
                        createdAtEnd: filters.dateRange[1]?.toISOString(),
                    }
                  : {}),
              dateRange: undefined,
          }
        : undefined;
    return { requestIds, filters: processedFilters };
}

export async function exportPriceChangeRequests(
    requestIds: string[] | null,
    filters?: ExportFilters,
): Promise<Blob> {
    return excelExportHttpClient.postBlob(
        '/export/price-change-requests',
        buildPriceChangeExportRequestBody(requestIds, filters),
    );
}

export async function exportPriceSurveys(
    surveyIds: string[] | null,
    filters?: ExportSurveyFilters,
): Promise<Blob> {
    return excelExportHttpClient.postBlob('/export/price-surveys', {
        surveyIds,
        filters: filters ?? undefined,
    });
}

export async function exportSurveyItems(
    surveyId: string,
    includeCostPricesAndMargins?: boolean,
): Promise<Blob> {
    return excelExportHttpClient.postBlob('/export/survey-items', {
        surveyId,
        includeCostPricesAndMargins,
    });
}

export async function exportSurveyActivity(surveyId: string): Promise<Blob> {
    return excelExportHttpClient.postBlob('/export/price-survey-activity', {
        surveyId,
    });
}
